import React, { Component } from "react";

class InterestRateContent extends Component {
  render() {
    return (
      <section className="section testimonial-area ptb_100">
        <div className="container text-center">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-10 col-lg-8">
              <h2 className="mt-4 mb-3">Interest Rate Policy</h2>
              {/* <p className="mb-3">Last Updated on December 29, 2025</p> */}
              <div className="col-12 col-md-12 row">
                <div style={{ textAlign: "start" }}>
                  Reserve Bank of India (“RBI”) Master Direction - Non-Banking
                  Financial Company - Systemically Important Non-Deposit taking
                  Company and Deposit taking Company (Reserve Bank) Directions,
                  2016 (RBI/DNBR/2016-17/45 Master Direction DNBR. PD.
                  008/03.10.119/2016-17) and Fair Lending Practice - Penal
                  Charges in Loan Accounts [RBI/2023-24/53
                  DoR.MCS.REC.28/01.01.001/2023-24] issued by the Reserve Bank
                  of India, all NBFCs are required to have a Board of Directors
                  (“Board”) approved interest rate model and a policy on penal
                  charges.
                  <br />
                  <br />
                  Keeping in view the RBI's guidelines as cited above,
                  guidelines as amended from time to time, and the good
                  governance practices, Monk Capital Private Limited (“Company”)
                  has framed the following internal guidelines, policies,
                  procedures and interest rate model for its lending business
                  which has been approved by its Board.
                </div>
                <h3 className="mt-4 w-100 row justify-content-start">
                  A. Objective of the policy
                </h3>
                <h3 className="mt-4 mb-2">1. Establish Benchmark Rates</h3>
                <p style={{ textAlign: "start" }}>
                  Determine benchmark rates for various borrower segments and
                  outline the principles and methodology for determining
                  spreads, leading to the final rates charged to borrowers.
                </p>
                <h3 className="mt-4 mb-2">
                  2. Transparent Communication of Interest Rates
                </h3>
                <p style={{ textAlign: "start" }}>
                  Clearly communicate the annualized rate of interest to
                  borrowers, including the approach for risk gradation and the
                  rationale for applying different interest rates across
                  borrower categories.
                </p>
                <h3 className="mt-4 mb-2">3. Accessibility and Transparency</h3>
                <p style={{ textAlign: "start" }}>
                  Publish the interest rates and the risk gradation methodology
                  on the company's website to ensure accessibility and
                  transparency.
                </p>
                <h3 className="mt-4 mb-2">4. Principles for Penal Charges</h3>
                <p style={{ textAlign: "start" }}>
                  Outline broad principles for levying penal charges in a fair
                  and consistent manner.
                </p>
                <h3 className="mt-4 w-100 row justify-content-start">
                  B. Interest Rate:
                </h3>
                <p style={{ textAlign: "start" }}>
                  The average yields and the rate of interest under each product
                  offered by the Company are decided from time to time, giving
                  due consideration to the following factors:
                  <ol
                    style={{
                      padding: 20,
                    }}
                  >
                    <li className="mb-2">
                      1. The cost of funds on the borrowings, as well as costs
                      incidental to those borrowings, taking into consideration
                      the average tenure, market liquidity, refinancing avenues
                      etc.
                    </li>
                    <li className="mb-2">
                      2. Inherent credit and default risk in our business,
                      particularly trends with sub-groups / customer segments of
                      the loan portfolio.
                    </li>
                    <li className="mb-2">
                      3. Nature of lending, for example the associated principal
                      / tenure.
                    </li>
                    <li className="mb-2">
                      4. Nature and value of securities and collateral offered
                      by customers (if applicable).
                    </li>
                    <li className="mb-2">
                      5. Risk profile of customer - professional qualification,
                      stability in earnings, financial positions (salary range,
                      type of employment, number of active loans, outstanding
                      balance, etc.), past repayment track record with us or
                      other lenders, credit score of customers, etc. and
                    </li>
                    <li className="mb-2">
                      6. Industry trends, that is determined by the rate of
                      interest offered by other competitor NBFCs. The Company
                      considers the aforementioned factors while arriving at a
                      rate of interest. Additionally, under this Interest Rate
                      Policy:
                    </li>
                    <li className="mb-2">
                      a. The Company shall adopt a discrete interest rate policy
                      which means that the rate of interest for the same product
                      and tenor availed during same period by different
                      customers may not to be standardized and may vary for
                      different customers depending upon consideration of any or
                      combination of above factors.
                    </li>
                    <li className="mb-2">
                      b. The interest rates offered would be on fixed basis.
                      Changes in interest rates would be decided at any
                      periodicity, depending upon market volatility and
                      competitor review.
                    </li>
                    <li className="mb-2">
                      c. Annualized rate of interest would be intimated to the
                      customer and the Company shall mention the penal charges
                      and other important charges in the sanction letter and the
                      loan agreement.
                    </li>
                    <li className="mb-2">
                      d. Interest rates would be intimated to the customers at
                      the time of sanction / availing of the loan and EMI
                      apportionment towards interest and principal dues would be
                      made available to the customer.
                    </li>
                    <li className="mb-2">
                      e. Besides normal interest, the Company may levy
                      additional / penal charges for delay or default in making
                      payments of any dues. These additional or penal charges
                      for different products or facilities would be decided by
                      the respective business / product heads and duly approved
                      by the Board.
                    </li>
                    <li className="mb-2">
                      f. Besides these charges, stamp duty, GST and other cess
                      would be collected at applicable rates. Any revision in
                      these charges would be from prospective effect. These
                      charges would be decided upon by respective business /
                      product heads in consultation with operations, finance and
                      legal heads and duly approved by the Board.
                    </li>
                    <li className="mb-2">
                      g. Besides interest, other financial charges like
                      processing fees, cheque bouncing charges, pre- payment/
                      foreclosure charges, cheque swaps, cash handling charges,
                      RTGS/ other remittance charges, commitment fees, charges
                      on various other services like issuing NO DUE
                      certificates, NOC, letters ceding charge on assets/
                      security, security swap & exchange charges etc. would be
                      levied by the Company wherever considered necessary.
                      Besides the base charges, the GST and other cess would be
                      collected at applicable rates. Any revision in these
                      charges would be with prospective effect. A suitable
                      condition in this regard would be incorporated in the loan
                      agreement. These charges would be decided upon
                      collectively by the management of the Company and duly
                      approved by the Board.
                    </li>
                    <li className="mb-2">
                      h. While deciding the charges, the practices followed by
                      the competitors in the market may also be taken into
                      consideration.
                    </li>
                    <li className="mb-2">
                      i. Claims for refund or waiver of charges / penal charges
                      / additional interest would normally not be entertained by
                      the Company and it is at the sole discretion of the
                      Company to deal with such requests.
                    </li>
                    <li>
                      j. Interest rate models, base lending rate and other
                      charges, and their periodic revisions are made available
                      to our prospective and existing customers through our
                      website and mobile application.
                    </li>
                  </ol>
                </p>
                <h3 className="mt-4 w-100 row justify-content-start">
                  C. Interest Rate Model
                </h3>
                <p style={{ textAlign: "start" }}>
                  The interest rate for credit facilities extended by Monk
                  Capital Private Limited is driven by benchmark rate of Monk
                  Capital plus the risk premium associated with the
                  borrower/facility.
                </p>
                <h3 className="mt-3 mb-2">Benchmark Rate</h3>
                <p style={{ textAlign: "start" }}>
                  Monk Capital benchmark rate for onward lending is based on
                  Marginal Cost of Lending Rate (MCLR) concept a function of the
                  following factors:
                  <ul style={{ padding: 20 }}>
                    <li className="mb-2">• Weighted average cost of funds</li>
                    <li className="mb-2">
                      • Administrative and operational costs
                    </li>
                    <li className="mb-2">• Tenor premium</li>
                    <li>• Profit margin</li>
                  </ul>
                </p>
                <h3 className="mt-4 mb-2">Risk Premium</h3>{" "}
                <p style={{ textAlign: "start" }}>
                  The Credit Risk Premium for all loan products is determined
                  for different customer segments and collateral types (as
                  applicable) to account for potential credit loss risks. It is
                  evaluated based on the following factors:
                  <ol>
                    <li className="mb-2">
                      a. Credit and Default Risk: The likelihood of the borrower
                      defaulting on the loan.
                    </li>
                    <li className="mb-2">
                      b. Historical Performance: Trends observed in similar
                      homogeneous client groups.
                    </li>
                    <li className="mb-2">
                      c. Borrower Profile: Personal and financial
                      characteristics of the borrower.
                    </li>
                    <li className="mb-2">
                      d. Repayment Track Record: The borrower's history of
                      repaying loans.
                    </li>
                    <li className="mb-2">
                      e. Credit Bureau Score: Creditworthiness as reflected in
                      their credit score.
                    </li>
                    <li className="mb-2">
                      f. Geographic Location: The borrower's location and its
                      associated risks.
                    </li>
                    <li className="mb-2">
                      g. Location Delinquency Trends: Default trends in the
                      borrower's area.
                    </li>
                    <li className="mb-2">
                      h. Customer Indebtedness: The borrower's existing debt
                      obligations.
                    </li>
                  </ol>
                  The range of Risk Premium will normally remain within range of
                  8-12%, depending upon the above factors.
                  <br />
                  <br />
                  The Rate of Interest that shall be charged to the customers
                  for availing its loan products will range between a minimum of
                  17.5% p.a to maximum of 36% p.a.
                </p>
                <h3 className="mt-4 mb-2 w-100 row justify-content-start">
                  D. Approach for Risk Gradation
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  The Company grants credit facilities only to those customers
                  who it believes have both the intention and the ability to
                  discharge their obligations.
                  <ol style={{ padding: 20 }}>
                    <li className="mb-2">
                      1. To execute smooth underwriting process, the Company
                      carries out different processes as per Know Your Customer
                      guidelines and allocates credit grade for each customer.
                    </li>
                    <li className="mb-2">
                      2. When assessing credit transactions, the Company focuses
                      on critical principles like history of the Borrower,
                      Financial Leverage, Liquidity and Sources of Cash,
                      education and stability and Profitability of Operations.
                    </li>
                    <li className="mb-2">
                      3. The determination of a customer's credit grading is
                      generally distinguished by the asset type and its use and
                      is mostly based on four general Categories, Character,
                      Capacity, Capital and Collateral.
                    </li>
                    <li className="mb-2">
                      4. The individual assessment criteria for the customer
                      credit grading can be classified into each of these
                      aspects. All credit submissions will be classified into
                      MoneyMonk Risk Score varying from 100-900.
                    </li>
                    <li>
                      5. The interest rate applicable to each loan account,
                      within the applicable range shall also be assessed on a
                      case specific basis, based on evaluation of various other
                      factors such as:
                      <ul style={{ padding: 20 }}>
                        <li className="mb-2">
                          • Interest rate trend prevailing in the money market.
                        </li>
                        <li className="mb-2">
                          • Long term prospects of business with the borrower.
                        </li>
                        <li className="mb-2">
                          • Loan specific costs including operations and
                          collection costs.
                        </li>
                        <li className="mb-2">• Company's cost of borrowing.</li>
                        <li className="mb-2">
                          • Customer negotiations / deviations, and
                        </li>
                        <li>• Upfront charges.</li>
                      </ul>
                    </li>
                  </ol>
                  Depending on the product, the interest rates would be offered
                  on fixed basis and charged on reducing balance method.
                </p>
                <h3 className="mt-4 mb-2 w-100 row justify-content-start">E. Interest rate communication</h3>
                <p style={{ textAlign: "start" }}>
                  Interest rates would be intimated to the customers at the time
                  of sanction / availing of the loan. Repayment schedule as per
                  the product availed by the customer and will be made available
                  to customer in the sanction letter as well as the Loan
                  Agreement.
                  <br />
                  <br /> The rates of interest are subject to change as the
                  situation warrants and are subject to the discretion of the
                  management and/or changes to extraneous cost factors which
                  affects the setting up of the interest rate.
                  <br />
                  <br />
                  The Company will mention penal charges charged for late
                  repayment in bold in the loan agreement.
                </p>
                <h3 className="mt-4 mb-2 w-100 row justify-content-start" style={{ textAlign: "start" }}>
                  F. Charges related loan application Processing, Documentation,
                  and Other incidental charges
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  All processing, documentation, and other charges levied are
                  explicitly stated in the loan documents. These charges vary
                  depending on factors such as the loan product, exposure limit,
                  customer segment, and geographical location. They generally
                  reflect the costs incurred in providing services to customers.
                  Market practices, including those of competitors, are also
                  considered when determining these charges.
                </p>
                <h3 className="mt-4 mb-2 w-100 row justify-content-start">G. Penalty Charges</h3>{" "}
                <p style={{ textAlign: "start" }}>
                  Penal charges are applicable in cases of non-compliance with
                  the material terms and conditions of the loan contract by the
                  borrower. The following key principles apply:
                  <ul style={{ padding: 20 }}>
                    <li className="mb-2">
                      • No Penal Interest on Defaults: The Company does not levy
                      penal interest on defaults.
                    </li>
                    <li className="mb-2">
                      • No Penal Interest on Defaults: The Company does not levy
                      penal interest on defaults.
                    </li>
                    <li className="mb-2">
                      • Additional to Overdue Interest: Penal charges are
                      separate from the overdue interest, which is calculated at
                      the contracted rate of interest on the outstanding
                      principal for the delay period.
                    </li>
                    <li>
                      • Legal Recourse: The imposition of penal charges does not
                      preclude the Company from pursuing legal action, including
                      repossession of the asset, after issuing a notice to the
                      borrower.
                    </li>
                  </ul>
                  <br />
                  The amount and rationale for penal charges shall be clearly
                  communicated to customers through the loan agreement and
                  sanction letter. Moreover, they are explicitly disclosed son
                  the company websites in the Schedule of Charges section.
                </p>
                <h3
                  className="mt-4 mb-2 w-100 row justify-content-start"
                >
                  H. Schedule of Charges
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  <ul style={{ padding: 20 }}>
                    <li className="mb-2 fw-5">• Preclosure Charges:</li>
                    <li className="mb-2 ml-4">
                      • Refer to the{" "}
                      <a href="/loanclosurepolicy">preclosure policy</a> for
                      detailed information.
                    </li>
                    <li className="mb-2 fw-5">• Prepayment Charges:</li>
                    <li className="mb-2 ml-4">
                      • Refer to the prepayment policy for detailed information.
                    </li>
                    <li className="mb-2 fw-5">• Penalty Charges:</li>
                    <li className="mb-2 ml-4">
                      • Penalty charges are calculated at an annualized rate of
                      36% + appropriate GST on the overdue principal amount,
                      applied on a daily basis without compounding.
                    </li>
                    <li className="mb-2 fw-5">• Bounce Charges:</li>
                    <li className="mb-2 ml-4">
                      • A flat fee of Rs.550 + appropriate GST.
                    </li>
                    <li className="mb-2 fw-5">• Credit Report Charges:</li>
                    <li className="mb-2 ml-4">
                      • A fixed fee of Rs. 50 + appropriate GST is charged for
                      obtaining a credit report.
                    </li>
                    <li className="mb-2 fw-5">• Insurance Charges:</li>
                    <li className="mb-2 ml-4">• NA</li>
                    <li className="mb-2 fw-5">• GST Charges:</li>
                    <li className="mb-2 ml-4">
                      • Currently, all our charges will attract 18% GST as per
                      the Government regulations.
                    </li>
                  </ul>
                </p>
                <h3
                  className="mt-4 mb-2 w-100 row justify-content-start"
                >
                  I. Loan products profile of the Company
                </h3>
                <p style={{ textAlign: "start" }}>
                  Product 1: - Personal Loans - Self Employed
                </p>
                <table style={{ width: "100%", marginTop: 5 }}>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                          width: "50%",
                        }}
                      >
                        Principal
                      </td>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                          width: "50%",
                        }}
                      >
                        ₹ 1500 - ₹ 30000
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                          width: "50%",
                        }}
                      >
                        Tenure
                      </td>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                          width: "50%",
                        }}
                      >
                        3 Months-12 Months
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                          width: "50%",
                        }}
                      >
                        Interest Rates (per annum)
                      </td>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                          width: "50%",
                        }}
                      >
                        {" "}
                        17.95 % - 33.55 %
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                          width: "50%",
                        }}
                      >
                        Processing Fees
                      </td>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                          width: "50%",
                        }}
                      >
                        1 % - 5 %
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                          width: "50%",
                        }}
                      >
                        Annual Percentage Rate (APR) range
                      </td>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                          width: "50%",
                        }}
                      >
                        30%-86%
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p style={{ textAlign: "start", marginTop: 18 }}>
                  Product 2: - Personal Loans - Salaried
                </p>
                <table style={{ width: "100%", marginTop: 5 }}>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                          width: "50%",
                        }}
                      >
                        Principal
                      </td>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                          width: "50%",
                        }}
                      >
                        ₹ 10000 - ₹ 200000
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                          width: "50%",
                        }}
                      >
                        Tenure
                      </td>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                          width: "50%",
                        }}
                      >
                        6 Months - 24 Months
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                          width: "50%",
                        }}
                      >
                        Interest Rates (per annum)
                      </td>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                          width: "50%",
                        }}
                      >
                        17.95 % - 30.55 %
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                          width: "50%",
                        }}
                      >
                        Processing Fees
                      </td>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                          width: "50%",
                        }}
                      >
                        1 % - 5 %
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                          width: "50%",
                        }}
                      >
                        Annual Percentage Rate (APR) range
                      </td>
                      <td
                        style={{
                          border: "1px solid #bfbfbf",
                          textAlign: "start",
                          padding: 5,
                        }}
                      >
                        30%-86%
                      </td>
                    </tr>
                  </tbody>
                </table>
                <h3
                  className="mt-4 mb-2 w-100 row justify-content-start"
                >
                  J. Review of Policy
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  The policy shall be reviewed periodically or as needed to
                  accommodate changes in the model, such as the addition or
                  removal of components used in benchmark calculations. The
                  Board, as applicable, shall have the authority to make
                  necessary prospective amendments to this policy at any time,
                  either at its own discretion or with the required concurrence.
                  <br />
                  <br />
                  This policy shall be published on the Company's website in
                  compliance with the Company's Fair Practices Code and the
                  guidelines issued by the Reserve Bank of India (RBI).
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default InterestRateContent;
